var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#FFF2F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6043 9.5758V9.33334C15.6043 8.44738 14.8861 7.72917 14.0001 7.72917C13.1141 7.72917 12.3959 8.44738 12.3959 9.33334V9.5758C11.0047 9.74511 9.70497 10.1313 8.55844 10.6901C8.34124 10.7959 8.25096 11.0578 8.35681 11.275C8.46266 11.4922 8.72455 11.5825 8.94176 11.4766C10.3952 10.7683 12.1309 10.3542 14.0001 10.3542C15.8692 10.3542 17.605 10.7683 19.0584 11.4766C19.2756 11.5825 19.5375 11.4922 19.6434 11.275C19.7492 11.0578 19.659 10.7959 19.4418 10.6901C18.2952 10.1313 16.9955 9.74511 15.6043 9.5758Z",
    fill: "#FF4136"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8335 12.3958C13.0751 12.3958 13.271 12.5917 13.271 12.8333V16.3333C13.271 16.575 13.0751 16.7708 12.8335 16.7708C12.5919 16.7708 12.396 16.575 12.396 16.3333V12.8333C12.396 12.5917 12.5919 12.3958 12.8335 12.3958Z",
    fill: "#FF4136"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1668 12.3958C15.4084 12.3958 15.6043 12.5917 15.6043 12.8333V16.3333C15.6043 16.575 15.4084 16.7708 15.1668 16.7708C14.9252 16.7708 14.7293 16.575 14.7293 16.3333V12.8333C14.7293 12.5917 14.9252 12.3958 15.1668 12.3958Z",
    fill: "#FF4136"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95068 11.0494L10.3453 17.6662C10.4326 18.8873 11.4486 19.8333 12.6727 19.8333H15.3275C16.5517 19.8333 17.5677 18.8873 17.6549 17.6662L18.0496 11.0494C16.8272 10.6047 15.454 10.3542 14.0001 10.3542C12.5463 10.3542 11.1731 10.6047 9.95068 11.0494ZM12.8335 12.3958C13.0751 12.3958 13.271 12.5917 13.271 12.8333V16.3333C13.271 16.575 13.0751 16.7708 12.8335 16.7708C12.5919 16.7708 12.396 16.575 12.396 16.3333V12.8333C12.396 12.5917 12.5919 12.3958 12.8335 12.3958ZM15.6044 12.8333C15.6044 12.5917 15.4085 12.3958 15.1669 12.3958C14.9252 12.3958 14.7294 12.5917 14.7294 12.8333V16.3333C14.7294 16.575 14.9252 16.7708 15.1669 16.7708C15.4085 16.7708 15.6044 16.575 15.6044 16.3333V12.8333Z",
    fill: "#FF4136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.fdc5ea9df8be24290830cfb468a6f520.svg";
export { ForwardRef as ReactComponent };